const COLORES = {
  verde: "#28a745",
  amarillo: "#ffc107",
  rojo: "#dc3545",
};

const IndicadorCalor = ({ color, size = 14 }) => (
  <span
    style={{
      display: "inline-block",
      width: size,
      height: size,
      borderRadius: "50%",
      backgroundColor: COLORES[color] || COLORES.rojo,
      flexShrink: 0,
    }}
    title={color}
  />
);

export default IndicadorCalor;
